import { gql } from '@apollo/client';

export const DELETE_FINANCIAL_INDICATOR = gql`
  mutation deleteFinancialIndicator($input: DeleteFinancialIndicatorInput) {
    deleteFinancialIndicator(input: $input) {
      commandId
    }
  }
`;

export const EXPORT_FINANCIAL_INDICATOR_LIST = gql`
  mutation exportFinancialIndicatorList($filters: ExportFinancialIndicatorListInput) {
    exportFinancialIndicatorList(filters: $filters) {
      fileId
      fileName
      filePath
    }
  }
`;
